export const RoomKindType = {
  GuestRoom: 'guestRoom',
  SpaceRoom: 'spaceRoom',
} as const
export type RoomKindType = (typeof RoomKindType)[keyof typeof RoomKindType]

export const LockType = {
  Manual: 'manual',
  RemoteLock: 'remoteLock',
  MiwaLock: 'miwaLock',
  SwitchBot: 'switchBot',
  KeyPo: 'keyPo',
  KeyVox: 'keyVox',
} as const
export type LockType = (typeof LockType)[keyof typeof LockType]

/** 部屋とデバイスの紐付けを /smart-lock/devices の一覧から行うロック種別 */
export type SmartLockDeviceType = typeof LockType.SwitchBot | typeof LockType.KeyPo | typeof LockType.KeyVox
export const isSmartLockDeviceType = (lockType: LockType): lockType is SmartLockDeviceType =>
  ([LockType.SwitchBot, LockType.KeyPo, LockType.KeyVox] as LockType[]).includes(lockType)

export const ApiCredentialField = {
  ApiToken: 'apiToken',
  ApiSecret: 'apiSecret',
} as const
export type ApiCredentialField = (typeof ApiCredentialField)[keyof typeof ApiCredentialField]
export type ApiCredential = Partial<Record<ApiCredentialField, string>>

/** 連携に必要な認証情報は接続先ごとに異なるため、種別ごとに入力項目を持たせる */
const apiCredentialFieldsByLockType: Partial<Record<LockType, ApiCredentialField[]>> = {
  [LockType.KeyPo]: [ApiCredentialField.ApiToken],
  [LockType.KeyVox]: [ApiCredentialField.ApiToken, ApiCredentialField.ApiSecret],
}
export const pickApiCredentialFields = (lockType: LockType): ApiCredentialField[] => apiCredentialFieldsByLockType[lockType] ?? []

export interface LockSetting {
  roomKind: RoomKindType
  lockType: LockType
}

export interface AccountInfo {
  lockType: LockType
  isEnabled: boolean
  isConnected: boolean
}

export interface Device {
  id: string
  name: string
  serialNumber: string | undefined
}
